import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { PropTypes } from "prop-types";
import Button from "components/atoms/Button/Button";

import "../WidgetDialog.scss";

function WidgetType({ widget, handleWidgetTypeClick, dashboardWidgets }) {
  const [widgetCount, setWidgetCount] = useState(0);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const widgets = dashboardWidgets || [];
    setWidgetCount(widgets.filter((currentWidget) => currentWidget.type === widget.type).length);
  }, []);

  // Square is disabled when either the widget is not yet available or if the widget already exists while it only allows 1.
  const squareDisabled = (!widget.multipleAllowed && widgetCount > 0) || !widget.available;

  const widgetType = (
    <div
      className={`square ${squareDisabled && "square-disabled"}`}
      onClick={() => (squareDisabled ? null : handleWidgetTypeClick(widget.type))}
      role="button"
      tabIndex={0}
      style={{ color: squareDisabled ? "#A6ABAD" : "#000000" }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid={widget.testId}
    >
      <div className="content">
        <div className="d-flex flex-column">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ opacity: squareDisabled ? 0.3 : 1, marginBottom: "9px" }}
          >
            {widget.icon}
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <p className="widget-name text-center p-0" style={{ marginBottom: "40px" }}>
              {widget.info.title}
            </p>
            <p
              style={{
                position: "absolute",
                bottom: 20,
                textAlign: "center",
                opacity: hover && !squareDisabled ? 0 : 1,
                transform: hover && !squareDisabled ? "translateY(20px)" : "translateY(0px)",
                transition: "transform 0.2s ease-in, opacity 0.1s linear 0.1s",
              }}
              className="widget-description pr-3 pl-3 m-0"
            >
              {widget.info.description}
            </p>
            {!squareDisabled && (
              <Button
                style={{
                  position: "absolute",
                  bottom: 20,
                  opacity: hover ? 1 : 0,
                  transform: hover ? "translateY(0px)" : "translateY(-20px)",
                  transition: "transform 0.2s ease-out 0.1s, opacity 0.07s linear 0.16s",
                  borderRadius: "16px",
                  padding: "8px 20px",
                }}
              >
                <FormattedMessage id="general.add" defaultMessage="Add" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  if (squareDisabled)
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip>
            {!widget.multipleAllowed && widgetCount > 0 && (
              <FormattedMessage id="dashboard.widgetDialog.widgetType.alreadyAdded" defaultMessage="Already added (Max 1)" />
            )}
            {!widget.available && (
              <FormattedMessage id="dashboard.widgetDialog.widgetType.notAvailable" defaultMessage="Not available" />
            )}
          </Tooltip>
        }
      >
        {widgetType}
      </OverlayTrigger>
    );
  return widgetType;
}

WidgetType.propTypes = {
  widget: PropTypes.instanceOf(Object).isRequired,
  handleWidgetTypeClick: PropTypes.func.isRequired,
  dashboardWidgets: PropTypes.instanceOf(Array),
};

WidgetType.defaultProps = {
  dashboardWidgets: [],
};

export default WidgetType;
